import React from "react";
import { Type } from "discover.medical.react-component-library";

export const SubscriptionInfo = ({
  subscriptionDetails,
  isSubscriptionDetailNotEmpty,
}) => (
  <section className="my-subscription__info">
    <Type element="h2" styledAs="h4" fontFamily="secondary" marginBottom="sm">
      Subscription Info
    </Type>
    <div>
      <span>{subscriptionDetails?.stripePlanDtoExt?.productName}</span>
      <span>
        {isSubscriptionDetailNotEmpty
          ? `$${(
              parseFloat(subscriptionDetails.priceOutputDto?.total) -
              parseFloat(subscriptionDetails.priceOutputDto?.calculatedTax)
            ).toFixed(2)}`
          : 0}
      </span>
    </div>
    <div className="my-subscription__info-taxes">
      <span>Taxes</span>
      <span>
        {isSubscriptionDetailNotEmpty
          ? `$${subscriptionDetails.priceOutputDto?.calculatedTax}`
          : 0}
      </span>
    </div>
    <div className="my-subscription__info-total">
      <span>Total (USD)</span>
      <span>
        {isSubscriptionDetailNotEmpty
          ? `$${subscriptionDetails.priceOutputDto?.total}`
          : 0}
      </span>
    </div>
  </section>
);
